/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddFeaturedListingRequest,
    IdResponse,
} from '../models';

export interface FeaturedListingApiControllerAddFeaturedListingRequest {
    addFeaturedListingRequest: AddFeaturedListingRequest;
}

export interface FeaturedListingApiControllerRemoveFeaturedListingRequest {
    id: string;
}

/**
 * 
 */
export class FeaturedListingApi extends runtime.BaseAPI {

    /**
     */
    async featuredListingApiControllerAddFeaturedListingRaw(requestParameters: FeaturedListingApiControllerAddFeaturedListingRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.addFeaturedListingRequest === null || requestParameters.addFeaturedListingRequest === undefined) {
            throw new runtime.RequiredError('addFeaturedListingRequest','Required parameter requestParameters.addFeaturedListingRequest was null or undefined when calling featuredListingApiControllerAddFeaturedListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-listings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addFeaturedListingRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async featuredListingApiControllerAddFeaturedListing(requestParameters: FeaturedListingApiControllerAddFeaturedListingRequest): Promise<IdResponse> {
        const response = await this.featuredListingApiControllerAddFeaturedListingRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async featuredListingApiControllerRemoveFeaturedListingRaw(requestParameters: FeaturedListingApiControllerRemoveFeaturedListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling featuredListingApiControllerRemoveFeaturedListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-listings/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featuredListingApiControllerRemoveFeaturedListing(requestParameters: FeaturedListingApiControllerRemoveFeaturedListingRequest): Promise<void> {
        await this.featuredListingApiControllerRemoveFeaturedListingRaw(requestParameters);
    }

}
